/* ============
 * Find the postal.
 * ============
 *
 * Found postal.
 */

import Vue from 'vue';
import postalTransformer from './../../transformers/postal';

const success = ({ data }, resolve) => {
  const postal = postalTransformer.fetch(data);

  resolve(postal);
};

const failed = () => {
};

// Display the postal.
export default postCode => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`postal/${postCode}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/postal/find.js